import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from '@mui/material/Typography';
import { useSnackbar } from 'notistack';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import withReducer from '../../../store/withReducer';
import FuseScrollbars from '../../../../@fuse/core/FuseScrollbars';
import FuseSvgIcon from '../../../../@fuse/core/FuseSvgIcon';
import NotificationCard from './NotificationCard';
import { dismissItem, getNotifications, selectNotifications } from './store/dataSlice';
import reducer from './store';
import { closeNotificationPanel, selectNotificationPanelState, toggleNotificationPanel } from './store/stateSlice';
import { getUser } from '../../../api/users';

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.background.default,
    width: 320,
  },
}));

function NotificationPanel(props) {
  const { keycloak, initialized } = useKeycloak();
  const [idUser, setIdUser] = useState('');
  const [role, setRole] = useState('');
  const roleKeycloak = keycloak?.realmAccess?.roles[0];

  useEffect(() => {
    if (keycloak?.tokenParsed?.sub) {
      const id = keycloak?.tokenParsed?.sub;
      const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];
      setIdUser(id);
      setRole(roleId);
      dispatch(
        getNotifications({
          idUser: id,
          roleId,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak?.tokenParsed]);

  const location = useLocation();
  const dispatch = useDispatch();
  const state = useSelector(selectNotificationPanelState);
  const notifications = useSelector(selectNotifications);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    if (state) {
      dispatch(closeNotificationPanel());
    }
    // eslint-disable-next-line
	}, [location, dispatch]);

  function handleClose() {
    dispatch(closeNotificationPanel());
  }

  function handleDismiss(id) {
    dispatch(
      dismissItem({
        idUser,
        roleId: role,
        idFile: id,
      })
    );
  }

  return (
    <StyledSwipeableDrawer
      open={state}
      anchor="right"
      onOpen={(ev) => {}}
      onClose={(ev) => dispatch(toggleNotificationPanel())}
      disableSwipeToOpen
    >
      <IconButton className="m-4 absolute top-0 right-0 z-999" onClick={handleClose} size="large">
        <FuseSvgIcon color="action">heroicons-outline:x</FuseSvgIcon>
      </IconButton>
      {notifications.length > 0 ? (
        <FuseScrollbars className="p-16">
          <div className="flex flex-col">
            <div className="flex justify-between items-end pt-136 mb-36">
              <Typography className="text-28 font-semibold leading-none">Notificaciones</Typography>
            </div>
            {notifications.map((item) => (
              <NotificationCard key={item.id} className="mb-16" item={item} onClose={handleDismiss} />
            ))}
          </div>
        </FuseScrollbars>
      ) : (
        <div className="flex flex-1 items-center justify-center p-16">
          <Typography className="text-24 text-center" color="text.secondary">
            No tiene notificaciones.
          </Typography>
        </div>
      )}
    </StyledSwipeableDrawer>
  );
}

export default withReducer('notificationPanel', reducer)(memo(NotificationPanel));
